import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ProfileCarrierModel } from '@libs/core/pt-api';

@Injectable()
export class CarrierInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  private carrier!: ProfileCarrierModel;

  constructor() {
    this.authService.currentCarrier$.subscribe((carrier) => (this.carrier = carrier));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let clonedReq = request;

    if (this.carrier) {
      clonedReq = request.clone({
        headers: request.headers.set('Carrier', this.carrier.id.toString()),
      });
    }

    return next.handle(clonedReq);
  }
}
